import SalesOrder from './SalesOrder';
import workspaceCombinedQuery from '../../queries/sales/SalesCombinedWorkspaceQuery.graphql';

import { formActionsForPermissions, quoteFormActionsForPermissions } from 'actions/sales/SalesOrderAction';
import { workspaceForPermissions } from 'actions/sales/SalesOrderWorkspaceAction';

const SalesCombined = {
  ...SalesOrder,
  type: 'SalesOrder',
  title: 'Quotes & Orders',
  formUrlFromFunction: (rowData) => {
    return rowData.orderType === 'QUOTE' ? '/Sales/Quote/Details/' : '/Sales/Order/Details/';
  },
  workspacePredefinedFilters: [],
  workspaceUrl: '/Sales/CombinedSales/Workspace/',
  workspace: workspaceCombinedQuery,
  screenReference: ['SALES_ORDERS', 'SALES_QUOTES'], //Requires BOTH of these permissions for any form action (View/Edit/Create/Delete).
  actions: [...formActionsForPermissions, ...quoteFormActionsForPermissions, ...workspaceForPermissions],
};

export default SalesCombined;
